
	<h1 mat-dialog-title>Update available</h1>
	<mat-dialog-content>
		<p>There is an update available for Capture Me. It is recommended to update the app before you continue using it. Updating usually takes a couple of seconds. Do you want to update?</p>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button mat-button (click)="_dialogRef.close()">Cancel</button>
		<button mat-button color="primary" (click)="_dialogRef.close(true)">Update</button>
	</mat-dialog-actions>